import { render } from "./questions-model.vue?vue&type=template&id=3a648f55"
import script from "./questions-model.vue?vue&type=script&lang=js"
export * from "./questions-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__